module.exports = __webpack_public_path__ + "static/media/pragneshgandhi.d0add698.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/pragneshgandhi.webp
// module id = 772
// module chunks = 0